module.exports = __webpack_public_path__ + "static/media/linkedin.ef93a97e.svg";